<template>
  <a-modal
      class="project-page"
      centered
      :title="`巨量项目列表 (${model.name})`"
      :width="'85%'"
      :mask-closable="false"
      :visible="showProjectPage"
      :confirmLoading="loading"
      :bodyStyle="{ padding: 0 }"
      :footer="null"
      @cancel="close"
  >
    <a-layout id="layout">
      <div class="search-wrapper">
        <a-space>
          <a-button type="primary" @click="search">刷新</a-button>
          <!-- <a-button @click="createAnchor" type="primary" icon="plus" v-if="accessTo('createAnchor')">创建锚点</a-button> -->
        </a-space>
      </div>

      <a-layout-content id="layout-content">
        <a-table
            size="small"
            :columns="columns"
            :row-key="record => record.project_id"
            :data-source="data"
            :pagination="pagination"
            :loading="loading"
            :transform-cell-text="$helper.emptyFormat"
            @change="handleTableChange"
        >

        <template slot="opt_status" slot-scope="row">
          <a-switch 
           v-model="row.show_opt_status"
           @change="updateProject(row.project_id, 'opt_status',  row.opt_status)"
          />
       </template>

        <template slot="budget" slot-scope="row">
          {{ row.delivery_setting.budget_mode === 'BUDGET_MODE_INFINITE' ? '不限' : '日预算' }}<br>
          【{{ row.delivery_setting.budget || '-' }}】<br>
       </template>

 
        </a-table>
      </a-layout-content>
    </a-layout>


    <create-anchor-form
    v-if="showCreateForm"
    :showCreateForm.sync="showCreateForm"
    :anchorModel="anchorModel"
    @success="refresh"
    />

  </a-modal>

</template>

<style lang="less" scoped>
@import 'Project';
</style>

<script>
import Project from './Project'

export default Project
</script>

